import { defineMessage } from 'react-intl';
import type { DateRangePresetId } from './date-range-presets';

/**
 * Message descriptors for each preset label. Used with $t() for menu items.
 * Ids are static for formatjs extraction.
 */
export const dateRangePresetMessages: Record<
  DateRangePresetId,
  ReturnType<typeof defineMessage>
> = {
  today: defineMessage({
    id: 'common.dateRangeSelector.preset.today',
    defaultMessage: 'Hoy',
  }),
  yesterday: defineMessage({
    id: 'common.dateRangeSelector.preset.yesterday',
    defaultMessage: 'Ayer',
  }),
  lastHour: defineMessage({
    id: 'common.dateRangeSelector.preset.lastHour',
    defaultMessage: 'Última hora',
  }),
  last24Hours: defineMessage({
    id: 'common.dateRangeSelector.preset.last24Hours',
    defaultMessage: 'Últimas 24 horas',
  }),
  last7Days: defineMessage({
    id: 'common.dateRangeSelector.preset.last7Days',
    defaultMessage: 'Últimos 7 días',
  }),
  last14Days: defineMessage({
    id: 'common.dateRangeSelector.preset.last14Days',
    defaultMessage: 'Últimos 14 días',
  }),
  last30Days: defineMessage({
    id: 'common.dateRangeSelector.preset.last30Days',
    defaultMessage: 'Últimos 30 días',
  }),
  last90Days: defineMessage({
    id: 'common.dateRangeSelector.preset.last90Days',
    defaultMessage: 'Últimos 90 días',
  }),
  last180Days: defineMessage({
    id: 'common.dateRangeSelector.preset.last180Days',
    defaultMessage: 'Últimos 180 días',
  }),
  lastWeek: defineMessage({
    id: 'common.dateRangeSelector.preset.lastWeek',
    defaultMessage: 'Semana pasada',
  }),
  lastMonth: defineMessage({
    id: 'common.dateRangeSelector.preset.lastMonth',
    defaultMessage: 'Mes pasado',
  }),
  thisWeek: defineMessage({
    id: 'common.dateRangeSelector.preset.thisWeek',
    defaultMessage: 'Esta semana',
  }),
  thisMonth: defineMessage({
    id: 'common.dateRangeSelector.preset.thisMonth',
    defaultMessage: 'Este mes',
  }),
  yearToDate: defineMessage({
    id: 'common.dateRangeSelector.preset.yearToDate',
    defaultMessage: 'Desde inicio del año',
  }),
  fromCustomDateUntilNow: defineMessage({
    id: 'common.dateRangeSelector.preset.fromCustomDateUntilNow',
    defaultMessage: 'Desde fecha personalizada hasta ahora...',
  }),
  customFixedDateRange: defineMessage({
    id: 'common.dateRangeSelector.preset.customFixedDateRange',
    defaultMessage: 'Rango de fechas fijo personalizado...',
  }),
};

/** Full label for "from custom date until now": {from} is the formatted start date (e.g. "{from} hasta ahora"). */
export const dateRangeLabelToNow = defineMessage({
  id: 'common.dateRangeSelector.labelToNow',
  defaultMessage: '{from} hasta ahora',
});
